import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SectionHeader from "./SectionHeader";

const FAQS = [
  {
    q: "What types of workers does RK Enterprises supply?",
    a: "We supply factory workforce, housekeeping staff, industrial labor, skilled and semi-skilled workers, and shift-based contract staff across multiple industries.",
  },
  {
    q: "How quickly can you deploy workers to our site?",
    a: "Standard deployment for verified clients begins within 48–72 hours. Larger requirements (50+ workers) typically deploy in phases over 5–10 days depending on the role and location.",
  },
  {
    q: "What shift models do you support?",
    a: "We support both 12-hour 2-shift models (8 AM – 8 PM and 8 PM – 8 AM) and 8-hour 3-shift models (8 AM – 4 PM, 4 PM – 12 AM, 12 AM – 8 AM).",
  },
  {
    q: "Are PF and ESI compliance handled by RK Enterprises?",
    a: "Yes. We handle full statutory compliance including PF, ESI, bonus, increments, and overtime as per government norms. Documentation is available to client companies on request.",
  },
  {
    q: "What benefits do employees get?",
    a: "Employees receive PF after 3 months, bonus after 6 months, increment after 9 months, accommodation, daily meals (Tiffin, Lunch, Coffee, Dinner), salary before the 8th every month, overtime, attendance incentives, and 3 monthly leaves.",
  },
  {
    q: "How do I apply for a job at RK Enterprises?",
    a: "Visit our Careers page and fill the Apply Now form with your details and resume. Our recruitment team will get in touch within 2–3 working days.",
  },
];

export default function FAQ() {
  return (
    <section
      className="bg-[#F8FAFC] py-16 md:py-24"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Frequently asked"
          title="Answers to common questions"
          description="If you have a question that isn't listed here, reach us via the contact form or WhatsApp."
          align="center"
          testid="faq-header"
        />
        <div className="mt-10">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border border-[#E2E8F0] rounded-sm bg-white mb-3 px-5"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-[#0F172A] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#475569] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
